export const isKeyInType = <T extends object>(
  value: T,
  key: unknown,
): key is keyof T => (key as keyof T) in value;
